/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import { format } from 'libphonenumber-js';
import * as mTypes from '../../mutation-types';

const state = {
  permits: [],
};

const getters = {
  permits: state => state.permits,
};

const methods = {
  formatPhoneNr(user) {
    const mobileCountry = user.mobileCountry;
    const mobile = user.mobile;
    if (user && mobile !== null) {
      return format({ mobileCountry, phone: mobile.toString() }, 'International_plaintext');
    }
    return '';
  },
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    // TODO: has to be limit for now
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/permits?productId=${payload.id}&limit=10000`).then((response) => {
      const tableData = [];
      response.data.items.forEach((permit) => {
        tableData.push({
          parkingCardNr: permit.parkingCardNr,
          name: permit.user ? permit.user.name : null,
          phone: permit.user ? methods.formatPhoneNr(permit.user) : null,
          vehicle: permit.vehicle ? permit.vehicle.vehicleReg : null,
          userId: permit.user ? permit.user.id : null,
        });
      });
      commit(mTypes.DATA_FETCHED, tableData);
    });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, permits) {
    state.permits = permits;
  },
  [mTypes.CLEAR_STATE](state) {
    state.permits = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  methods,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/permits.js